import { render } from "./FontColorSelectBlock.vue?vue&type=template&id=d8ec4240&ts=true"
import script from "./FontColorSelectBlock.vue?vue&type=script&lang=ts"
export * from "./FontColorSelectBlock.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__